import { render, staticRenderFns } from "./user-form.vue?vue&type=template&id=70dae9f2&scoped=true"
import script from "./user-form.vue?vue&type=script&lang=js"
export * from "./user-form.vue?vue&type=script&lang=js"
import style0 from "./user-form.vue?vue&type=style&index=0&id=70dae9f2&prod&scoped=true&lang=css"
import style1 from "./user-form.vue?vue&type=style&index=1&id=70dae9f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dae9f2",
  null
  
)

export default component.exports